import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { createSelector, select, Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { State } from '@ordersnproducts/modules/one-click-order/reducers';
import { getAvailableContractsBalance } from '@ordersnproducts/modules/order-builder/modules/specification/selectors/contract.selector';
import { SelectOptionI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-i';
import { SelectOptionLoaderI } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-select/models/select-option-loader-i';
import { loadAvailableContracts } from '@ordersnproducts/modules/shared/utils/contracts-with-balance-loader.helper';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getOneClickContractsAvailable } from '../../selectors/one-click-contract.selector';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';

const contractsAndBalance = (index: number) =>
  createSelector(getOneClickContractsAvailable(index), getAvailableContractsBalance, (contracts, balance) => ({
    contracts,
    balance,
  }));

@Injectable()
export class OneClickContractsBalanceLoaderService implements SelectOptionLoaderI {
  constructor(
    private store: Store<State>,
    private translate: TranslateService,
  ) {}

  loadOptions(formGroup: UntypedFormGroup, config?: FieldConfig): Observable<SelectOptionI[]> {
    return this.store.pipe(
      select(contractsAndBalance(config['at'])),
      map(({ contracts, balance }) => {
        return loadAvailableContracts(contracts, balance, this.translate);
      }),
    );
  }
}
